// extracted by mini-css-extract-plugin
module.exports = {"title":"Cart_page_title__1QiXC","hook":"Cart_page_hook__2ny4-","item":"Cart_page_item__DIjt4","price":"Cart_page_price__3qlpb"};